export default {"src":"/_next/static/media/The_Giving_Block.1fce14e7.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};